import { IExperiment } from './IExperimentManager';

/**
 * Whether an experiment has concluded and shipped a winner: everyone is
 * enrolled (rollout 100, or no rollout gate) and a single variant is at
 * weight 100, so every user gets the same experience. These stay in the
 * codebase but have no live split left to exercise.
 */
export function isFullyRolledOut(experiment: Pick<IExperiment, 'rollout' | 'variants'>): boolean {
  if (experiment.rollout !== undefined && experiment.rollout !== 100) {
    return false;
  }
  return experiment.variants.some((variant) => variant.weight === 100);
}
